import { Injectable } from '@angular/core';
import { Query, toBoolean } from '@datorama/akita';
import { AuthStore, AuthState } from './auth.store';

@Injectable({ providedIn: 'root' })
export class AuthQuery extends Query<AuthState> {

  isLoggedIn$ = this.select(state => toBoolean(state.token));
    user$ = this.select(state => state.user);

  constructor(protected override store: AuthStore) {
    super(store);
  }

  isLoggedIn() {
		return toBoolean(this.getValue().token);
  }

  isAdmin() {
		return toBoolean(this.getValue().user.is_admin);
  }
  
  token() {
    return this.getValue().token;
  }

}
